import { v4 as uuidv4 } from 'uuid';export type FileType = "listing";

export interface DigitalFolder {
  id: string
  folderName: string
  parentId: string | null
  displayOrder: number
  listingId: string | null
}

export interface DigitalItem {
  id: string
  folderId: string
  title: string
  url: string
  filename: string
  contentType: string
  sizeInBytes: number
  key: string
  isVideo: boolean
  status: string
  nextStatusActionDue: number
  createdAt: number
  createdById: string 
  updatedAt: number
  updatedById: string
}

export interface DigitalFolderPublic {
  id: string
  folderName: string
  parentId: string | null
  displayOrder: number
  listingId: number
  digitalItems_on_folder: DigitalItemPublic[]
}

export interface DigitalItemPublic {
  id: string
  parentId: string
  title: string
  url: string
  displayOrder: number
  extension?: string | null
  statusId: string
}

export const UPLOADED_FILES_FOLDER_NAME = "Uploaded Files";

export const createEmptyDigitalFolder = (folderName = UPLOADED_FILES_FOLDER_NAME, parentId: string | null = null, displayOrder = 0): DigitalFolderPublic => ({
  id: uuidv4(),
  folderName: folderName,
  parentId,
  displayOrder,
  listingId: 0,
  digitalItems_on_folder: []
});

export interface FilePresignRequirements{
  locationId: string,
  listingId: string,
  filename: string, 
  contentType: string,
}

export interface FilePresignReturn { uploadUrl: string; publicUrl: string; key: string }
  
export interface TransferNewUploadedFilesVariables {
  digitalItemIds: string[]
  objectId?: string
}

export const blockedExtensions = new Set([
  'exe',
  'com',
  'scr',
  'msi',
  'msp',
  'dll',
  'ocx',
  'sys',
  'cpl',
  'drv',

  'bat',
  'cmd',
  'ps1',
  'psm1',
  'vbs',
  'vbe',
  'js',
  'jse',
  'wsf',
  'wsh',
  'hta',

  'php',
  'php3',
  'php4',
  'php5',
  'phtml',
  'asp',
  'aspx',
  'jsp',
  'cgi',
  'pl',
  'py',

  'html',
  'htm'
]);


export const blockedMimeTypes = new Set([
  'application/x-msdownload',
  'application/x-msdos-program',
  'application/x-msi',

  'text/javascript',
  'application/javascript',

  'text/html',

  'application/x-httpd-php',
  'text/x-python',
  'application/x-perl',
  'application/x-sh',
  'text/x-shellscript',

  'application/x-powershell',
  'application/java-archive',
  'application/x-shockwave-flash'
]);

export function isFileTypeBlocked(file: {name: string, type: string}): boolean {
  const extension = file.name.split('.').pop()?.toLowerCase();
  if (extension && blockedExtensions.has(extension)) {
    return true;
  }

  if (blockedMimeTypes.has(file.type)) {
    return true;
  }

  return false;
}